import useApi from '../api';

export async function fetchPlayerSubscriptionById(
  itemId: number|string
) {
  const {get} = useApi();
  const { responseBody } = await get('api/playersubscriptions/'+itemId, {isLogoutOnInvalidAuth: true})
  return responseBody;
}

export type FiltersSubmissionPayload  = {
  "organizations": number[],
  "locations": number[],
  "orientations": number[],
  "playerTags": string[]
}

export async function fetchMatchingPlayers(filters: FiltersSubmissionPayload ) {
  const {post} = useApi();
  const { responseBody } = await post(
    'api/playersubscriptions/previewmatchingplayers', filters, {isLogoutOnInvalidAuth: true}
  );
  return responseBody;
}

export type FetchAvailableIntegrationInstancesOptions = {
  filters?: {
    implementationKeys: string[]
  }
}

export async function fetchAvailableIntegrationInstances({
  filters
}: FetchAvailableIntegrationInstancesOptions = {}) {
  const { post } = useApi();

  const implementationKeyFilters = filters?.implementationKeys
    ? [{
        name: "FILTER_IMPLEMENTATION_KEY",
        selectedOptions: filters.implementationKeys,
      }]
    : [];
  
  const filtersPrepared = {
    limit: 100,
    offset: 0,
    query: {
      fieldNames: ["Name", "IntegrationImplementationId", "ConfigValues"],
      term: "",
    },
    filters: [
      {
        name: "FILTER_CREATED",
        selectedOptions: ["All"],
      },
      {
        name: "FILTER_MODIFIED",
        selectedOptions: ["All"],
      },
      ...implementationKeyFilters,
    ],
    sorts: [
      {
        fieldName: "Name",
        isDescending: false,
      },
    ],
  };

  const { responseBody } = await post("IntegrationInstanceSearch", filtersPrepared, {
    isLogoutOnInvalidAuth: true,
  });
  return responseBody;
}